// extracted by mini-css-extract-plugin
export default {"textGradient":"About_textGradient__D9x1a"};